import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Table,
  Form,
} from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { BiRupee } from "react-icons/bi";
import "./CustomerList.css";
import { Link } from "react-router-dom";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import axios from "axios";
import { Button } from "react-bootstrap";

const parsePossibleDate = (value) => {
  if (!value) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return new Date(value);
  const parts = value.split("/");
  if (parts.length === 3) {
    const d = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10) - 1;
    const y = parseInt(parts[2], 10);
    const dt = new Date(y, m, d);
    return isNaN(dt) ? null : dt;
  }
  const dt = new Date(value);
  return isNaN(dt) ? null : dt;
};

const parseDateDMY = (value) => {
    if (!value) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return new Date(value);
    const sep = value.includes("-") ? "-" : value.includes("/") ? "/" : null;
    if (sep) {
      const parts = value.split(sep);
      if (parts.length === 3 && parts[2].length === 4) {
        const d = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10) - 1;
        const y = parseInt(parts[2], 10);
        const dt = new Date(y, m, d);
        return isNaN(dt) ? null : dt;
      }
    }
    const dt = new Date(value);
    return isNaN(dt) ? null : dt;
  };

const SalaryAided = () => {
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [salaryData, setSalaryData] = useState([]);

  useEffect(() => {
    axios.post(`${API_BASE_URL}salary_aided_list.php`)
      .then((response) => {
        if (response.data.head.code === 200) {

          const list = response.data.body;

          setSalaryData(list);
          // setRecords(list);

          console.log("test", list);  // now NOT empty

          // const found = list.find(r => Number(r.user_id) === userId) || null;
          // setRecord(found);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setSalaryData([]);
          // setRecords([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setSalaryData([]);
        // setRecords([]);
      });
  }, []);

  // const calculateSalary = (item) => {
  //   const gross =
  //     item.basic +
  //     item.sp +
  //     item.wa +
  //     item.da +
  //     item.hra +
  //     item.ma;

  //   const deduction =
  //     item.tpf +
  //     item.tpfd +
  //     item.cpsr +
  //     item.cpsa1 +
  //     item.gis +
  //     item.nhis +
  //     item.faCoop +
  //     item.ptItSr;

  //   const netSalary = gross - deduction;

  //   return { gross, deduction, netSalary };
  // };

  // filter (search + date range)
  const filteredData = salaryData.filter((item) => {
    if (search) {
      const q = search.toLowerCase();
      if (!item.name || !item.name.toLowerCase().includes(q)) return false;
    }
    if (fromDate || toDate) {
      const reqDate = parseDateDMY(item.added_date);
      if (!reqDate) return false;
      if (fromDate) {
        const from = new Date(fromDate + "T00:00:00");
        if (reqDate < from) return false;
      }
      if (toDate) {
        const to = new Date(toDate + "T23:59:59");
        if (reqDate > to) return false;
      }
    }
    return true;
  });

  // pagination over filtered results
  const {
    currentPage,
    totalPages,
    currentItems,
    handlePageChange,
    indexOfFirstItem,
  } = usePagination(filteredData, 25); // show 2 rows per page

  const handleExport = () => {
    console.log("asfsffasdfaf", fromDate, toDate);
    console.log("AIDED Salary CSV sheet");
    /*  */
    axios({
      url: `${API_BASE_URL}salary_aided_excel.php`, // your PHP export URL
      data: {
        from_date: fromDate,
        to_date: toDate
      },
      method: 'POST', // or GET depending on your PHP script
      responseType: 'blob', // important for file download
    })
      .then((response) => {
        // Create a Blob from the response
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        // Change filename to .csv
        link.setAttribute('download', 'salary_aided_sheet.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error downloading CSV:", error);
      });

  };

  return (
    <>
      <Container fluid className="my-4 outer-container">

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
          <p></p>
          <h2 className="text-center">Aided Staff Salary</h2>
          <Button
            variant="success"
            onClick={handleExport}
          // href="/mnt/data/your_excel_file.xlsx"  // <-- replace with your local Excel file path or URL
          // target="_blank"
          // rel="noopener noreferrer"
          // download  // Optional: triggers download instead of open in new tab
          >
            Export to Excel
          </Button>
        </div>
        {/* {currentItems.length === 0 && (
          <Container fluid className="outer-container my-4">
            <Row>
              <Col>
                <div className="not-found-box">Loading...</div>
              </Col>
            </Row>
          </Container>
        )} */}
        <Row className="mb-3">
          <Col md={4}>
            <Form.Label>Search</Form.Label>
            <Form.Control
              type="text"
              placeholder="Search by staff name"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
          <Col md={4}>
            <Form.Label>From Date</Form.Label>
            <Form.Control
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Col>
          <Col md={4}>
            <Form.Label>To Date</Form.Label>
            <Form.Control
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Col>
        </Row>

        <div className="table-pagination-wrapper">
          <div className="table-pagination-content">
            <Table bordered responsive className="table-striped customer-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Staff Name</th>
                  <th>DOJ</th>
                  <th>Basic</th>
                  <th>Gross</th>
                  <th>Deduction</th>
                  <th>Net Salary</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item, i) => {
                  // const calc = calculateSalary(item);
                  return (
                    <tr key={item.salary_id}>
                      {/* <td>{indexOfFirstItem + i + 1}</td> */}
                      <td>{currentItems.length - (indexOfFirstItem + i)}</td>
                      <td>{item.name}</td>
                      <td>{item.date_of_join}</td>
                      <td>
                        <BiRupee />
                        {item.basic}
                      </td>
                      <td>
                        <BiRupee />
                        {item.gross}
                      </td>
                      <td>
                        <BiRupee />
                        {item.deduction}
                      </td>
                      <td>
                        <BiRupee />
                        {item.net_salary}
                      </td>
                      <td className="action-icons">
                        <Link to={`/viewsalaryaided/${item.salary_id}`}>
                          <FaEye className="view-icon" />
                        </Link>
                        {/* <Link to={`/editsalaryaided/${item.id}`}>
                          <FaEdit className="edit-icon" />
                        </Link>
                        <FaTrash
                          className="delete-icon"
                          onClick={() => handleDelete(item.id)}
                          style={{ cursor: "pointer" }}
                        /> */}
                      </td>
                    </tr>
                  );
                })}

                {currentItems.length === 0 && (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </Container>
    </>
  );
};

export default SalaryAided;
